/**
 * Repeated marketing section header:
 *   flourish tagline → heading → optional subhead paragraph
 *
 * Props:
 *   - flourish:         string shown inside the .flourish ribbon (optional)
 *   - title:            string or ReactNode for the heading
 *   - subhead:          optional string or ReactNode rendered as a <p>
 *   - subheadClassName: extra classes applied to the subhead <p>
 *   - align:            "center" (default) | "left"
 *   - spaceY:           tailwind vertical-spacing class, default "space-y-3"
 *   - className:        extra classes for the wrapper (e.g. margin-bottom)
 *   - as:               heading tag, default "h2". Use "h1" for the page's
 *                       primary heading so every page has exactly one <h1>.
 */
export default function SectionHeading({
  flourish,
  title,
  subhead,
  subheadClassName = "",
  align = "center",
  spaceY = "space-y-3",
  className = "",
  as: Heading = "h2",
}) {
  const isCenter = align === "center";
  const wrapperAlign = isCenter ? "text-center" : "text-left";
  const flourishAlign = isCenter ? "justify-center" : "";
  const subheadAlign = isCenter ? "max-w-xl mx-auto" : "max-w-xl";

  return (
    <div className={`${wrapperAlign} ${spaceY} ${className}`.trim()}>
      {flourish ? (
        <div className={`flourish ${flourishAlign}`.trim()}>
          <span>{flourish}</span>
        </div>
      ) : null}
      <Heading className="text-3xl md:text-5xl text-foreground">{title}</Heading>
      {subhead ? (
        <p className={`text-muted-foreground ${subheadAlign} ${subheadClassName}`.trim()}>
          {subhead}
        </p>
      ) : null}
    </div>
  );
}
